import React from 'react';
import PropTypes from 'prop-types';
import GridSection from '../GridSection';

function BenefitsSection({ event, site, section }) {
  return (
    <GridSection
      event={event}
      site={site}
      section={{
        ...section,
        styles: {
          ...section.styles,
          grid: {
            imageSize: 'huge',
            largeTitle: true,
          },
        },
      }}
    />
  );
}

BenefitsSection.propTypes = {
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
};

export default BenefitsSection;



// WEBPACK FOOTER //
// ./src/site-render/src/BenefitsSection/BenefitsSection.js